<template>
  <base-list-view
    @state-scroll="scrollList"
  >
    <div class="sponsorship__wrapper">
      <div
        v-for="item of sponsorshipList"
        :key="item.id"
        class="item"
      >
        <div class="item-image__wrapper">
          <img :src="item.title_img" alt="">
        </div>
        <div
          v-if="item.description_format === 'html'"
          v-html="item.description"
          class="item-description"
        />
        <div
          v-if="item.link_app"
          class="link__wrapper"
        >
          <router-link
          :to="{
            name: item.link_app,
            params: { id: item.link_ident }
          }"
          class="btn-item-link"
          >{{ item.link_title }}</router-link>
        </div>
      </div>
      <system-card
        v-if="systemMessage"
        :system-message="systemMessage"
        :cbFunc="repeatGetPage"
      />
      <pre-loader v-if="isLoading"/>
    </div>
  </base-list-view>
</template>
<script>
import sponsorship from '@/components/mixins/api/methodsSponsorShip';
import baseListView from '@/components/shared/baseListView.vue';
import SystemCard from '@/components/shared/upCard/SystemCard.vue';
import appBaseNav from '@/components/mixins/appBaseNav';

export default {
  name: 'SponsorShip',
  components: { baseListView, SystemCard },
  data() {
    return {
      sponsorshipList: [],
      curPage: 1,
      countPage: null,

      // itPriority: null,

      isLastDownloaded: false,
      systemMessage: null,
    };
  },
  mixins: [appBaseNav, sponsorship],
  mounted() {
    this.$store.commit('setPageTitle', this.$t('sponsorship.header_title'));
    this.getPage();
  },
  methods: {
    getPage() {
      this.isLoading = true;
      this.getSponsorshipList()
        .then((data) => {
          this.$emit('turnOff', {
            stateDownload: false,
            stateCheckInbox: false,
          });
          if (data?.results && Array.isArray(data.results)) {
            this.sponsorshipList = [...this.sponsorshipList, ...data.results];
            console.log(data);
          } else {
            this.isLastDownloaded = false;
            this.systemMessage = this.$t('system.bad_connect');
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    scrollList(prop) {
      if (prop.endPage && !this.isLoading && this.isLastDownloaded) {
        this.curPage += this.isLastDownloaded ? 1 : 0;
        this.getPage();
      }
    },
  },
};
</script>
<style lang="scss">
.sponsorship {
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .item {
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-radius: 16px;
      padding-bottom: 10px;
      overflow: hidden;
      background: #ffffff;

      &-image {
        &__wrapper {
          img {
            width: 100%;
            border-radius: 16px;
          }
        }
      }
      &-description {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 0 10px;

        a {
          color: #2D3038;
        }
        p, ul, li, h1, h2, h3, h4, h5 {
          margin: 0;
        }
        ul {
          padding-left: 20px;
          li::marker {
            color: #2D3038;
            font-size: 1.2em;
          }
        }
      }
    }
  }
}
.link__wrapper {
  display: flex;
  padding: 0 10px;
  justify-content: center;
  .btn-item-link {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 100%;
    height: 50px;
    padding: 0 25px;
    border-radius: 25px;
    background: #2D3038;
    color: #ffffff;
    text-decoration: none;
    font-weight: 700;
  }
}
</style>
